// @ts-nocheck

export default {
  getExternalRequest (state) {
    return state.externalRequest
  }
}
